import { createFileRoute } from "@tanstack/react-router";
import { DeptContentForm } from "@/components/dept-content/DeptContentForm";
import { DEPARTMENTS } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/structure/departments/new")({
  component: () => <DeptContentForm cfg={DEPARTMENTS} />,
});
